import { apiBaseURL } from "../ProjectConstants";

// POST: Add Supplier
async function handlePostSupplierList(supplierData, fetch) {
  console.log("handlePostSupplierList supplierData", supplierData);

  const body = {
    name: supplierData?.name || "",
    contact: supplierData?.contact || "",
    email: supplierData?.email || "",
    adress: supplierData?.adress || "",
    // IsAs9100Approved: supplierData?.IsAs9100Approved || "false",
  };

  const response = await fetch.post(`${apiBaseURL}/api/supplier`, body);

  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePostSupplierList body", body);
  console.log("handlePostSupplierList response", response);

  return {
    response,
    isDataGood,
  };
}

export default handlePostSupplierList;
